/* ==========================================================================
   Theme Toggle (Dark / Light)
   --------------------------------------------------------------------------
   Handles theme persistence, system detection, and live updates.
   ========================================================================== */

// (function () {
//   const root = document.documentElement;
//   const toggleBtn = document.getElementById('theme-toggle');

//   // ============================================================
//   // Helpers
//   // ============================================================

//   // Determine preferred theme
//   const getPreferredTheme = () => {
//     const saved = localStorage.getItem('theme');
//     if (saved) return saved;
//     return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
//   };

//   // Apply theme
//   const applyTheme = (theme) => {
//     root.dataset.theme = theme;
//     localStorage.setItem('theme', theme);
//   };

//   // ============================================================
//   // Initialization
//   // ============================================================
//   applyTheme(getPreferredTheme());

//   // ============================================================
//   // Toggle Button
//   // ============================================================
//   if (toggleBtn) {
//     toggleBtn.addEventListener('click', () => {
//       const newTheme = root.dataset.theme === 'dark' ? 'light' : 'dark';
//       applyTheme(newTheme);
//     });
//   }

//   // ============================================================
//   // System Theme Change Listener
//   // ============================================================
//   const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
//   mediaQuery.addEventListener('change', (e) => {
//     const systemTheme = e.matches ? 'dark' : 'light';
//     if (!localStorage.getItem('theme')) {
//       applyTheme(systemTheme);
//     }
//   });
// })();